<!-- 顶部导航条
 back: boolean 返回按钮是否显示  d:true（显示）
 right: boolean 右边三个点是否显示，d:false（不显示）
 selfGoBack: boolean 是否默认返回上一页,true:返回上一页,false:触发navBack事件 d: true
 title: string 标题名字
 @navBack event 父组件点击back按钮向上传播该事件
 -->
<template>
  <div>
    <nav class="wrapper" :style="{'margin-bottom': mb}">
      <div class="backbtn" @click="goBack">
        <ui-icon v-show="back" :name="iconName"></ui-icon>
      </div>
      <div class="title">
        {{title}}
      </div>
      <!-- <div>
        <div v-show="right" @click="emitClick('pointClick')" class="point3"></div>
      </div> -->
    </nav>
    <div class="nav_space"></div>
  </div>
</template>

<script>
  import {Icon} from "vx-mobile";

  export default {
    components: {},
    props: {
      title: {
        type: String,
        default: "标题"
      },
      back: {
        type: Boolean,
        default: true
      },
      // right: {
      //   type: Boolean,
      //   default: false
      // },
      iconName: {
        type: String,
        default: 'arrow-left'
      },
      mb: {
        type: String,
        default: '.2rem'
      },
      // selfGoBack: {
      //   type: Boolean,
      //   default: true
      // }
    },
    data() {
      return {}
    },
    methods: {
      goBack() {
        if(this.$store.state.routerFlag){
          this.$router.replace('/');
          this.$store.state.routerFlag = false;
        }else{
          // window.location.href="http://localhost:8082/pay"
          // console.log(12313)
          // window.opener=null
          // window.close
          window.history.back();
          this.$store.state.routerFlag = false;
        }
      },
      // emitClick(EventName) {
      //   this.$emit(EventName)
      // }
    },
    created() {
    },
    mounted() {
    }
  }
</script>
<style scoped>
  .wrapper {
    padding: 0 8px;
    width: 100%;
    display: flex;
    background: #fff;
    color: #292c2f;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .2rem;
    font-size: .35rem;
    position: fixed;
    top: 0;
    z-index: 10;
  }
  .nav_space{
    width: 100%;
    height: 100px;
  }
  .title {
    height: 0.88rem;
    line-height: 0.88rem;
    margin: 0 auto;
  }

  .backbtn {
    width: .6rem;
    height: .6rem;
  }

  .backbtn svg {
    width: .6rem;
    height: .6rem;
  }

  /* .point3 {
    background-image: url("../assets/img/point3.png");
    background-size: 100% 100%;
    width: 60px;
    height: 60px;
    margin-right: 10px;
  } */
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue